import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import DateRangeIcon from "@mui/icons-material/DateRange";
import FlightClassOutlinedIcon from "@mui/icons-material/FlightClassOutlined";

import { ComponentConfigProps, FilterData } from "../typing";
import FilterItemAdvisory from "./Advisory";
import FilterItemAircrafts from "./Aircrafts";
import FilterItemAirlines from "./Airlines";
import FilterItemAirport from "./Airport";
import FilterItemAirportInbound from "./AirportInBound";
import FilterItemAirportOutbound from "./AirportOutbound";
import FilterItemArrivalTime from "./ArrivalTime";
import FilterItemBanks from "./Banks";
import FilterItemCabins from "./Cabins";
import FilterItemConnectingAirports from "./ConnectingAirports";
import FilterItemConnectionTime from "./ConnectionTime";
import FilterItemDates from "./Dates";
import FilterItemDays from "./Days";
import FilterItemDepartureTime from "./DepartureTime";
import FilterItemDuration from "./Duration";
import FilterItemGridModeCabins from "./GridModeFilters/Cabins";
import FilterItemGridModeMaxPoints from "./GridModeFilters/MaxPoints";
import FilterItemGridModePremium from "./GridModeFilters/Premium";
import FilterItemGridModeTax from "./GridModeFilters/Tax";
import FilterItemMaxPoints from "./MaxPoints";
import FilterItemPremium from "./Premium";
import FilterItemPrograms from "./Programs";
import FilterItemStops from "./Stops";
import FilterItemTax from "./Tax";
import FilterItemTimes from "./Times";

/**
 * 注册的filter项目
 */
export const filterRegisterList: ComponentConfigProps[] = [
  {
    key: "date",
    label: "Date",
    component: FilterItemDates,
    defaultValue: [],
    icon: DateRangeIcon,
  },
  {
    key: "cabins",
    label: "Cabins",
    component: FilterItemCabins,
    defaultValue: [],
    icon: FlightClassOutlinedIcon,
  },
  {
    key: "gridModeCabins",
    label: "Cabins",
    component: FilterItemGridModeCabins,
    defaultValue: [],
  },
  {
    key: "programs",
    label: "Programs",
    component: FilterItemPrograms,
    defaultValue: [],
  },
  {
    key: "banks",
    label: "Cards",
    component: FilterItemBanks,
    defaultValue: [],
  },
  {
    key: "stops",
    label: "Stops",
    component: FilterItemStops,
    defaultValue: "-1",
  },
  {
    key: "airlines",
    label: "Airlines",
    component: FilterItemAirlines,
    defaultValue: [],
  },
  {
    key: "premium",
    label: "Premium Cabin %",
    component: FilterItemPremium,
    defaultValue: [],
  },
  {
    key: "gridModePremium",
    label: "Premium",
    component: FilterItemGridModePremium,
    defaultValue: [0, 0],
  },
  {
    key: "maxPoints",
    label: "Max Points",
    component: FilterItemMaxPoints,
    defaultValue: -1,
  },
  {
    key: "tax",
    label: "Tax",
    component: FilterItemTax,
    defaultValue: -1,
  },
  {
    key: "gridModeMaxPoints",
    label: "Max Points",
    component: FilterItemGridModeMaxPoints,
    defaultValue: [-1, -1, -1, -1],
  },
  {
    key: "gridModeTax",
    label: "Tax",
    component: FilterItemGridModeTax,
    defaultValue: [-1, -1, -1, -1],
  },
  {
    key: "days",
    label: "Days",
    component: FilterItemDays,
    defaultValue: [],
    // icon: CalendarMonthOutlinedIcon,
  },
  {
    key: "duration",
    label: "Duration",
    component: FilterItemDuration,
    defaultValue: -1,
  },
  {
    key: "times",
    label: "Times",
    component: FilterItemTimes,
    defaultValue: [0, 24, 0, 24],
  },
  {
    key: "connectionTime",
    label: "Connection Time",
    component: FilterItemConnectionTime,
    defaultValue: [],
  },

  {
    key: "aircrafts",
    label: "Aircrafts",
    inner_label: "Aircrafts",
    component: FilterItemAircrafts,
    defaultValue: [],
  },

  {
    key: "airportOutbound",
    label: "Departure Airports",
    inner_label: "Departure Airports",
    component: FilterItemAirportOutbound,
    defaultValue: [],
  },

  {
    key: "airportInbound",
    label: "Arrival Airports",
    inner_label: "Arrival Airports",
    component: FilterItemAirportInbound,
    defaultValue: [],
  },
  // {
  //   key: "departureTime",
  //   label: "Departure Time",
  //   component: FilterItemDepartureTime,
  //   defaultValue: [0, 24],
  // },
  // {
  //   key: "arrivalTime",
  //   label: "Arrival Time",
  //   component: FilterItemArrivalTime,
  //   defaultValue: [0, 24],
  // },
  {
    key: "connectingAirports",
    label: "Connecting Airports",
    inner_label: "Connecting Airports",
    component: FilterItemConnectingAirports,
    defaultValue: [],
  },
  {
    key: "advisory",
    label: "Advisory",
    component: FilterItemAdvisory,
    defaultValue: [],
  },
];

/**
 * 获取所有filter的默认值
 * @returns
 */
export const getFilterDefault = () => {
  return filterRegisterList.reduce(
    (result, item) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      result[item.key] = item.defaultValue;
      return result;
    },
    {
      excludeAirlines: [] as string[],
    } as FilterData
  );
};

export const getFilterConfigByKey = (key: string): ComponentConfigProps | undefined => {
  return filterRegisterList.find((item) => item.key === key);
};
